const alphalinkPlace = {
  alphalinkId: {
    label: "Id Alphalink",
  },
  alphalinkPlaceCreation: {
    label: "Création du site",
    flashbagMessage: "La création du site chez Alphalink a réussi",
    flashbagMessageFailure: "La création du site chez Alphalink a raté"
  }
};

export default alphalinkPlace;
